var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useCallback } from "react";
import { createPortal } from "react-dom";
import { Menu, Item, useContextMenu } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
var MENU_ID = "editor-context-menu";

function isBringForwardDisabled(_ref) {
  var _ref$props = _ref.props,
      selectedOverlay = _ref$props.selectedOverlay,
      canvas = _ref$props.canvas;
  var overlays = canvas.getObjects();
  return overlays.indexOf(selectedOverlay) === overlays.length - 1;
}

function isSendBackDisabled(_ref2) {
  var _ref2$props = _ref2.props,
      selectedOverlay = _ref2$props.selectedOverlay,
      canvas = _ref2$props.canvas;
  return canvas.getObjects().indexOf(selectedOverlay) === 0;
}

function Portal(_ref3) {
  var children = _ref3.children;
  return createPortal(children, document.body);
}

export default (function (Component) {
  return function (props) {
    var _useContextMenu = useContextMenu({
      id: MENU_ID
    }),
        show = _useContextMenu.show,
        hideAll = _useContextMenu.hideAll;

    var showContextMenu = useCallback(function (event, selectedOverlay, canvas, triggerChangedEvent) {
      event.preventDefault();
      show(event, {
        props: {
          selectedOverlay: selectedOverlay,
          canvas: canvas,
          triggerChangedEvent: triggerChangedEvent
        }
      });
    }, [show]);
    var handleItemClick = useCallback(function (_ref4) {
      var event = _ref4.event,
          _ref4$props = _ref4.props,
          selectedOverlay = _ref4$props.selectedOverlay,
          canvas = _ref4$props.canvas,
          triggerChangedEvent = _ref4$props.triggerChangedEvent;
      hideAll();

      switch (event.currentTarget.id) {
        case "bringForward":
          canvas.bringForward(selectedOverlay);
          break;

        case "bringToFront":
          canvas.bringToFront(selectedOverlay);
          break;

        case "sendBack":
          canvas.sendBackwards(selectedOverlay);
          break;

        case "sendToBack":
          canvas.sendToBack(selectedOverlay);
          break;

        case "delete":
          canvas.remove(selectedOverlay);
          break;
      }

      canvas.renderAll();
      canvas.discardActiveObject().renderAll();
      triggerChangedEvent();
    }, [hideAll]);
    return React.createElement(React.Fragment, null, React.createElement(Component, _extends({
      showContextMenu: showContextMenu,
      hideContextMenu: hideAll
    }, props)), React.createElement(Portal, null, React.createElement(Menu, {
      id: MENU_ID
    }, React.createElement(Item, {
      id: "bringForward",
      disabled: isBringForwardDisabled,
      onClick: handleItemClick
    }, "Bring forward"), React.createElement(Item, {
      id: "bringToFront",
      disabled: isBringForwardDisabled,
      onClick: handleItemClick
    }, "Bring to front"), React.createElement(Item, {
      id: "sendBack",
      disabled: isSendBackDisabled,
      onClick: handleItemClick
    }, "Send backward"), React.createElement(Item, {
      id: "sendToBack",
      disabled: isSendBackDisabled,
      onClick: handleItemClick
    }, "Send to back"), React.createElement(Item, {
      id: "delete",
      onClick: handleItemClick
    }, "Delete"))));
  };
});